<template>
  <div v-cloak>
    <div >
      <van-cell-group>
        <van-cell  v-if="westore.getters.logined" value="" is-link center @click="go_user">
          <div class="mine-head" style="display: flex;justify-content: flex-start">
            <van-image class="mine-head-image"  radius="8" :src="westore.state.user.userInfo.avatar"></van-image>
            <div class="mine-head-content">
              <span class="custom-title item nickname">{{westore.state.user.userInfo.nickname}}</span>
              <span class="custom-title item">{{westore.state.user.userInfo.create_time}}</span>
            </div>
          </div>
        </van-cell>
        <van-cell v-else value="请登录" is-link center @click="go_login">
          <template slot="title">
            <div class="mine-head">
              <van-image class="mine-head-image" radius="8" :src="images.default_head"></van-image>
            </div>
          </template>
        </van-cell>
      </van-cell-group>
      <!--<div class="vip-wrap">-->
        <!--<div class="vip-wrap-title" @click="go_vipinfo">-->
          <!--<van-icon name="question" class="weball-font-color-main"></van-icon>-->
          <!--<span>会员</span>-->
          <!--<div v-if="westore.getters.logined && westore.state.user.userInfo.is_vip===1" class="endtime">{{"到期时间：" + westore.state.user.userInfo.vip.end_time}}</div>-->
          <!--<div v-else class="endtime">包月更划算</div>-->
        <!--</div>-->
        <!--<van-button v-if="westore.getters.logined && westore.state.user.userInfo.is_vip===1" type="info" size="mini" @click="buy_vip">续费</van-button>-->
        <!--<van-button v-else type="info" size="mini" @click="buy_vip">开通</van-button>-->
      <!--</div>-->
      <van-grid :column-num="3" square center>
        <van-grid-item  class="weball-font-color-main"
                       icon="balance-pay"
                       text="点券充值"
                        @click="go_recharge">
        </van-grid-item>
        <van-grid-item  class="weball-font-color-main"
                        icon="balance-list-o"
                        text="点券明细"
                        @click="go_rechargelist">
        </van-grid-item>
        <van-grid-item icon="records" class="weball-font-color-main" text="已购分析" @click="go_buyed"> </van-grid-item>
        <van-grid-item icon="like-o" class="weball-font-color-main" text="我的关注"  :to="werouter.subscript.path" ></van-grid-item>
        <van-grid-item icon="chat-o" class="weball-font-color-main" text="我的消息"  :to="werouter.message.path"></van-grid-item>
      </van-grid>
    </div>

    <van-tabbar  @change="" route>
      <van-tabbar-item  icon="home-o" replace :to="werouter.index.path">首页</van-tabbar-item>
      <van-tabbar-item  icon="hot-o" replace :to="werouter.author.path">大神</van-tabbar-item>
      <van-tabbar-item  icon="medal-o" replace :to="werouter.match.path">赛事</van-tabbar-item>
      <van-tabbar-item  icon="chat-o" replace :to="werouter.message.path">消息</van-tabbar-item>
      <van-tabbar-item  icon="user-circle-o" replace :to="werouter.mine.path">我的</van-tabbar-item>
    </van-tabbar>
  </div>
</template>
<script>
    import ic_vip from '@/assets/ic_vip.png'
    import ic_setting from '@/assets/ic_setting.png'
    import ic_buyed from '@/assets/ic_buyed.png'
    import ic_dingyue from '@/assets/ic_dingyue.png'
    import default_head from '@/assets/default_head.png'
    export default {
        props: ['id'],
        name:'mine',
        data() {
            return {
                images:{
                    ic_vip:ic_vip,
                    ic_setting:ic_setting,
                    ic_buyed:ic_buyed,
                    ic_dingyue:ic_dingyue,
                    default_head:default_head
                }
            }
        },
        created(){
        },
        mounted() {
            this.getUserInfo();
        },
        methods:{
            getUserInfo:function(){
                let that = this;
                this.westore.dispatch('getUserInfo').then(user => {
                }).catch((res) => {
                    that.westore.commit('setToken', '')
                })
            },
            buy_vip:function(){
                let that = this;
                if(!this.westore.getters.logined){
                    this.$router.push({ name: this.werouter.login.name, query: { redirect_name: this.werouter.mine.name} });
                    return;
                }
                if(this.westore.getters.isbind){
                    this.westore.dispatch('payVip', {app_id:this.westore.state.app.app_id}).then(res => {
                        that.$toast("支付成功！");
                        that.getUserInfo();
                    }).catch((res) => {
                        that.$toast(res);
                    })
                }
                else{
                    this.$dialog.confirm({
                        title: '防止失联',
                        message: '绑定手机号，在各浏览器可用手机号登录！'
                    }).then((res) => {
                        if(res === 'confirm'){
                            this.$router.push({ name: this.werouter.bindphone.name})
                        }
                        else{
                            this.buy(item.data);
                        }
                    }).catch(() => {
                    });

                }

            },
            go_login:function () {
                this.$router.push(
                    { name: this.werouter.login.name, query: { redirect_name: this.werouter.mine.name}
                    }
                ).catch(function () {});
            },
            go_buyed:function(){
                if(!this.westore.getters.logined){
                    this.$router.push({ name: this.werouter.login.name, query: { redirect_name: this.werouter.mine.name} }).catch(function () {});;
                    return;
                }
                this.$router.push({ name: this.werouter.myproject.name}).catch(function () {});;
            },
            go_recharge:function(){
              if(!this.westore.getters.logined){
                this.$router.push({ name: this.werouter.login.name, query: { redirect_name: this.werouter.mine.name} }).catch(function () {});;
                return;
              }
              this.$router.push({ name: this.werouter.recharge.name}).catch(function () {});;
            },
            go_rechargelist:function(){
              if(!this.westore.getters.logined){
                this.$router.push({ name: this.werouter.login.name, query: { redirect_name: this.werouter.mine.name} }).catch(function () {});;
                return;
              }
              this.$router.push({ name: this.werouter.quanlist.name}).catch(function () {});;
            },
            go_user:function () {
                if(!this.westore.getters.logined){
                    this.$router.push({ name: this.werouter.login.name, query: { redirect_name: this.werouter.mine.name} }).catch(function () {});;
                    return;
                }
                this.$router.push({ name: this.werouter.userinfo.name}).catch(function () {});
            },
            go_vipinfo:function () {
                this.$dialog.alert({
                    messageAlign:'left',
                    title:'成为付费阅读会员须知',
                    message: '成为包月会员后，可以在会员期内，免费阅读所有需要付费的文章\n\n' +
                    '【月会员】有效期31天，费用599元，开通当天起开始累计31天。'
                });
            }
        }
    }
</script>
<style >
  .mine-head{
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
  }
  .mine-head-image{
    width:56px;
    height: 56px;
  }
  .mine-head-content{
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: flex-start;
    margin: 10px;
  }
  .mine-head-content .item{
    font-size: 14px;
    color: #888;
    margin: 2px;
  }
  .mine-head-content .nickname{
    font-size: 16px;
    color: #333;

  }
  .vip-wrap{
    font-size: 14px;
    padding: 10px 16px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
  .vip-wrap-title{
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
  }
  .vip-wrap-title span{
    margin: 0 15px 0 5px;
  }
  .vip-wrap-title .endtime{
    color: #888;
  }
</style>
